import { useEffect, type ReactNode } from 'react';
import { useRouteEntity } from '@/contexts/RouteEntityContext';

interface DirectRouteEntityProps {
  /** The sourceId for this route (e.g. 'plans', 'checkout'). Omit for home. */
  sourceId?: string;
  children: ReactNode;
}

/**
 * Resets RouteEntityContext for direct (non-DeterministicRouter) routes.
 * Prevents stale entity from a previous catch-all page from affecting layout
 * decisions (e.g. isBillingFlow hiding nav/footer on the home page).
 */
export function DirectRouteEntity({ sourceId, children }: DirectRouteEntityProps) {
  const { setCurrentEntity } = useRouteEntity();

  useEffect(() => {
    setCurrentEntity({
      type: sourceId ? 'route' : 'home',
      sourceId: sourceId ?? null,
      isPending: false,
    });
  }, [sourceId, setCurrentEntity]);

  return <>{children}</>;
}
